
import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill()
import { onMounted, onUnmounted, ref } from 'vue'
import { throttle } from 'lodash-es'

export default {
  name: 'LocalNavSide',

  props: {
    items: {
      type: Array,
      defaults: []
    },
    offset: {
      type: Number,
      default: 110
    }
  },

  setup(props: any) {
    const selectedId = ref(props.items[0]?.id)
    const checked = (id: string) => (selectedId.value === id ? 'checked' : '')

    const scrollContents = (id: string) => {
      const el = document.getElementById(id)
      if (!el) return
      window.scrollTo({
        top: el.offsetTop - props.offset,
        behavior: 'smooth'
      })
    }

    const reverseItems = [...props.items].reverse()
    const onScroll = throttle(() => {
      const height = window.innerHeight
      const id = reverseItems.find((nav: any) => {
        const el: any = document.getElementById(nav.id)
        if (!el) return false
        const rect = el.getBoundingClientRect()
        return height * 0.3 > rect.top
      })?.id
      if (id) selectedId.value = id
      else selectedId.value = props.items[0]?.id
    }, 100)
    onMounted(() => {
      onScroll()
      window.addEventListener('scroll', onScroll)
    })
    onUnmounted(() => {
      window.removeEventListener('scroll', onScroll)
    })

    return {
      checked,
      scrollContents
    }
  }
}
